<div class="bulk-upload-container">

  <div class="bulk-upload-div">
    <h2>Product Export</h2>
    <div class="upload-container">
      <button mat-raised-button color="primary" (click)="downloadTemplateConformation()">
        <mat-icon>download</mat-icon>
        Download Template
      </button>
      <button mat-raised-button color="primary" (click)="openExcelUploadDialog()">
        <mat-icon>cloud_upload</mat-icon>
        Upload Products
      </button>
    </div>
  </div>
  <div class="bulk-form-container mat-elevation-z2">
    <form [formGroup]="productForm" (ngSubmit)="addProduct()">
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Product Name</mat-label>
          <input matInput formControlName="productName" placeholder="Enter product name" (blur)="checkProductName()">
          <div class="error-message"
            *ngIf="productForm.get('productName')?.hasError('required') &&  productForm.get('productName')?.touched">
            {{ productNameErrorMessage }}
          </div>
          <div class="error-message" *ngIf="productForm.get('productName')?.hasError('productExists')  ">
            {{ productNameErrorMessage }}
          </div>
        </mat-form-field>

        <!-- <mat-form-field appearance="outline" class="form-field">
          <mat-label>Category</mat-label>
          <mat-select formControlName="categoryName" (selectionChange)="onCategorySelected($event.value)">
            <mat-option *ngFor="let category of categories" [value]="category" >
              {{category.name}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="productForm.get('categoryName')?.invalid && productForm.get('categoryName')?.touched">
            Category is required
          </mat-error>
        </mat-form-field> -->
        <mat-form-field appearance="outline" class="form-field">
          <mat-label>Category</mat-label>
          <input type="text" matInput placeholder="Search Category" [matAutocomplete]="categoryAuto"
            formControlName="categoryName" (input)="onCategoryInputChange($event)" (blur)="validateCategoryInput()"
            (keydown.enter)="selectCategoryFromInput()" />

          <mat-autocomplete #categoryAuto="matAutocomplete" (optionSelected)="onCategorySelected($event.option.value)">
            <mat-option *ngFor="let category of filteredCategories" [value]="category">
              {{ category.name }}
            </mat-option>
          </mat-autocomplete>
          <div class="error-message"
            *ngIf="productForm.get('categoryName')?.hasError('required') && productForm.get('categoryName')?.touched">
            Category is required
          </div>
        </mat-form-field>
        <mat-form-field class="form-field" appearance="outline">
          <mat-label>Specifications</mat-label>
          <input placeholder="Search Specification" matInput [formControl]="specInputControl"
            (blur)="onSpecInputBlur()" (input)="onSpecificationChange($event)"
            [matAutocomplete]="specificationAuto" (keydown.enter)="addSpecificationFromInput()" />

          <mat-autocomplete #specificationAuto="matAutocomplete"
            (optionSelected)="onSpecificationSelected($event.option.value)">
            <mat-option *ngFor="let spec of filteredSpecifications" [value]="spec">
              {{ spec.name }}
            </mat-option>
          </mat-autocomplete>
          <div class="error-message" *ngIf="specInputControl?.hasError('required') && specInputControl.touched">
            Specification is required.
          </div>

        </mat-form-field>

      </div>
      <label *ngIf="selectedSpecifications.length > 0">Selected Specifications : </label>
      <mat-chip-list aria-label="Specification list" class="chips-container">
        <mat-chip *ngFor="let spec of selectedSpecifications" [removable]="true" (removed)="removeSpecification(spec)">
          {{ spec }}
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>
      </mat-chip-list>

      <div class="form-row">

        <div class="image-upload-container form-field">
          <label for="productImages">Product Images</label>
          <div class="image-upload-area" (click)="fileInput.click()">
            <input #fileInput type="file" multiple (change)="onFilesSelected($event)" style="display: none"
              accept="image/*">
            <div class="upload-placeholder" *ngIf="!selectedImages.length">
              <mat-icon>add_photo_alternate</mat-icon>
              <span>Click to upload images</span>
            </div>

            <div class="image-preview-multiple" *ngIf="selectedImages.length > 0">
              <div class="image-thumb" *ngFor="let img of selectedImages; let i = index">
                <img [src]="img" alt="Product image preview">
                <button class="remove-image" (click)="removeImage(i, $event)">
                  <mat-icon>close</mat-icon>
                </button>
              </div>
            </div>
          </div>
          <mat-error *ngIf="imageError">
            {{imageError}}
          </mat-error>
        </div>

      </div>


      <div class="form-actions">
        <button type="button" mat-stroked-button (click)="resetForm()">Clear</button>
        <button type="submit" mat-raised-button color="primary"
          [disabled]="productForm.invalid || selectedImages.length === 0">Add Product</button>
      </div>
    </form>
  </div>


  <!-- Search Bar -->
  <!-- <div class="search-container">
      <mat-form-field appearance="outline" class="m-2 search-bar">
        <mat-icon matPrefix>search</mat-icon>
        <input matInput placeholder="Search" (input)="searchTerm($event)"
          [value]="searchKeyword ? searchKeyword.trim() : ''">
        <button type="button" (click)="clearSearch()" *ngIf="searchKeyword.trim()" matSuffix mat-icon-button
          aria-label="Clear" class="search-remove-container">
          <mat-icon class="category-clear-search">close</mat-icon>
        </button>
      </mat-form-field>
    </div> -->
  <div class="prod-mwe-table">
    <app-mwe-table [columns]="columns" [data]="filteredProducts" (pageChanged)="onPageChanged($event)"
      [currentPageChanged]="page" [hideHeader] [showHeader]="false" [showpagination]="true"
      [totalEntries]="totalEntries" (selectedAction)="selectedAction($event)"></app-mwe-table>
  </div>

  <ng-template #excelUploadDialog>
    <div class="excel-dialog-container">
      <div mat-dialog-title class="head-div">
        <mat-icon class="upload-icon">description</mat-icon>
        Upload Excel File
      </div>
  
      <mat-dialog-content class="excel-dialog-content">
        <div class="drop-zone" (click)="excelInput.click()">
          <input #excelInput type="file" accept=".xlsx,.xls" (change)="onExcelFileSelected($event)" hidden />
          <mat-icon *ngIf="!selectedExcelFile" class="drop-icon">cloud_upload</mat-icon>
          <p class="drop-text" *ngIf="!selectedExcelFile">Click or drag your Excel file here</p>
          <p class="file-name" *ngIf="selectedExcelFile">
            <mat-icon class="file-icon">check_circle</mat-icon>
            {{ selectedExcelFile.name }}
          </p>
        </div>
        <p *ngIf="excelError" class="error-text">{{ excelError }}</p>
      </mat-dialog-content>
  
      <mat-dialog-actions align="end" class="dialog-actions">
        <button mat-stroked-button (click)="dialogRef.close()">Cancel</button>
        <button mat-flat-button color="primary" [disabled]="!selectedExcelFile" (click)="submitExcel()">Upload</button>
      </mat-dialog-actions>
    </div>
  </ng-template>
  
</div>